export default __webpack_public_path__ + "static/staff-augmentation-35ae0f652c4afa60314bfc8bd2cb8596.webp";